// extracted by mini-css-extract-plugin
export var fadeInOut = "_20-3";
export var icon = "_20-4";
export var savedIndicator = "_20-2";
export var savingIndicator = "_20-0";
export var spin = "_20-1";